import type { SelectProps } from '@risk-smart/themed-cloudscape-components/select';
import CSelect from '@risk-smart/themed-cloudscape-components/select';
import { forwardRef, useMemo, useState } from 'react';

import { filterOptionsByVisibleText } from '../option-label-filter/filterOptionsByVisibleText';
import styles from './style.module.scss';

const Select = forwardRef<SelectProps.Ref, SelectProps>(
  ({ filteringType = 'auto', options, onLoadItems, ...props }, ref) => {
    const [filteringText, setFilteringText] = useState('');

    // See filterOptionsByVisibleText for why we override 'auto' filtering.
    const preFilter = filteringType === 'auto';

    const visibleOptions = useMemo(
      () =>
        preFilter
          ? filterOptionsByVisibleText(options, filteringText)
          : options,
      [options, filteringText, preFilter]
    );

    return (
      <div className={styles.select}>
        <CSelect
          {...props}
          filteringType={preFilter ? 'manual' : filteringType}
          options={visibleOptions}
          onLoadItems={(event) => {
            if (preFilter) {
              setFilteringText(event.detail.filteringText ?? '');
            }
            onLoadItems?.(event);
          }}
          ref={ref}
        />
      </div>
    );
  }
);
Select.displayName = 'Select';

export default Select;
